export default __webpack_public_path__ + "static/pexels-ron-lach-6714223-7eb1eb0d94d40383e6bbdd86b6cd24a6.jpg";